(function ($) {
    $.widget('femcare.singleFieldDate', {
        options: {},

        _create: function () {
            this.$input = this.element.find('input');

            var minDateString = this.element.attr('data-min-date');
            var maxDateString = this.element.attr('data-max-date');

            var instanceOptions = {
                changeMonth: true,
                changeYear: true
            };

            var minDate = minDateString && this.parseISOdate(minDateString);
            var maxDate = maxDateString && this.parseISOdate(maxDateString);

            if (minDate) {
                instanceOptions.minDate = minDate;
            }

            if (maxDate) {
                instanceOptions.maxDate = maxDate;
            }

            if (minDate && maxDate) {
                var minYear = minDate.getFullYear();
                var maxYear = maxDate.getFullYear();

                instanceOptions.yearRange = minYear + ":" + maxYear;
            }

            this.$input.datepicker(instanceOptions);
        },

        parseISOdate: function (dateString) {
            try {
                var parts = dateString.split('-');
                return new Date(parts[0], parts[1] - 1, parts[2]);
            } catch (error) {
                console.log('ISO date parse error');
                return null;
            }
        }
    });

}(jQuery));